import { Loader } from '@ui-kit/components/loader';
import BlockHeading from '@ui-kit/components/blockHeading';
import React, { useEffect, useState } from 'react';
import { useAsyncData } from '@utils/hooks';
import { Challenge, IChallengeService } from '../../model/interfaces';
import styles from './challenges.module.scss';
import Empty from '@ui-kit/components/empty';
import { ReactComponent as Back } from '../../assets/back.svg';
import { ReactComponent as Swords } from '../../assets/swords.svg';
import ChallengesList from './challengesList/challengesList';
import ChallengeDetails from './challengeDetails/challengeDetails';
import { t, useSubject } from '@base/utils/helpers';
import { container } from 'tsyringe';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';

export default function Challenges(props: { challengeService: IChallengeService }) {
  const [selectedChallenge, setSelectedChallenge] = useState<Challenge | undefined>(undefined);

  return (
    <div className={styles.challenges}>
      <ChallengesHeading
        selectedChallenge={selectedChallenge}
        onBack={() => setSelectedChallenge(undefined)}
      />
      <ChallengesContent
        challengeService={props.challengeService}
        selectedChallenge={selectedChallenge}
        setSelectedChallenge={setSelectedChallenge}
      />
    </div>
  );
}

function ChallengesHeading(props: { selectedChallenge?: Challenge; onBack: () => void }) {
  return (
    <BlockHeading>
      {props.selectedChallenge ? (
        <div className={styles.challengeInfoHeading}>
          <Back onClick={props.onBack} style={{ cursor: 'pointer' }} />
          <span>
            {props.selectedChallenge?.issuerName}{' '}
            <span style={{ textTransform: 'lowercase' }}>{t('vs')}</span>{' '}
            {props.selectedChallenge?.recipientName}
          </span>
        </div>
      ) : (
        t('challenges')
      )}
    </BlockHeading>
  );
}

function ChallengesContent(props: {
  challengeService: IChallengeService;
  selectedChallenge?: Challenge;
  setSelectedChallenge: (challenge?: Challenge) => void;
}) {
  const { challengeService, selectedChallenge, setSelectedChallenge } = props;
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const onUpdate = useSubject(challengeService.onChallengeChanged);
  const { data: challenges, loading } = useAsyncData<Challenge[]>(
    () => challengeService.getAllChallenges(),
    onUpdate
  );

  useEffect(() => {
    if (!onUpdate) setSelectedChallenge?.(undefined);
  }, [onUpdate, setSelectedChallenge]);

  if (loading) return <Loader />;
  if (!challenges || !challenges.length)
    return <Empty icon={<Swords className={styles.swords} />}>{t('no_available_challenges')}</Empty>;

  return selectedChallenge ? (
    <ChallengeDetails
      id={selectedChallenge.id}
      challengeService={challengeService}
      editable={selectedChallenge.issuerId === playersOnlineRepository.me?.userId}
      canSendMessages={[selectedChallenge.issuerId, selectedChallenge.recipientId].includes(
        playersOnlineRepository.me?.userId
      )}
    />
  ) : (
    <ChallengesList challenges={challenges} onClick={setSelectedChallenge} />
  );
}
